import apiClient from '@/services/api-client';

export default {
	sendToAll(payload) {
		return apiClient().post('/Communication/SendToAll', payload);
	},
	sendEmail(payload) {
		return apiClient().post('/Communication/SendEmail', payload);
	},
};
